import { post } from "@insite/client-framework/Services/ApiService";
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";

const emailsUrl = "/api/v1/promotionredemption";

export interface SubmitRedemptionFormApiParameter extends SubmitContactUsFormApiParameter {
    promotionToRedeem: string;
    todayDate: string;
    isRedemptionPage:string;
    emailTo?: string;
    npiNumber: string;
    firstName: string;
    lastName: string;
    specialty: string;
    areaOfInterest: string;
    practiceHospital: string;
    country: string;
    streetAddress: string;
    streetAddress2: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    email: string;
    serialNumbers: string;
    modelNumbers: string;
    invoiceNumbers: string;
    files: File[];
    physicianLicense: string;
    salesRepOrDistributor: string;
    additionalNotes: string;
    emailRecipients: string;
}

export function submitRedemptionForm(parameter: SubmitRedemptionFormApiParameter) {
    return post<SubmitRedemptionFormApiParameter, void>(`${emailsUrl}/redeem`, parameter);
}
